import { API_PREFIX_MEDIA_PATH } from "@/constants/prefix-path-api"
import { AxiosRequestConfig } from "axios"
import { HttpClient } from "../../../../app/api/HttpClient"

export const fetchMediaAll = async () => {
  return await HttpClient.get(`${API_PREFIX_MEDIA_PATH}/files`)
}

export const fetchMedia = async (page = 1, pageSize = 24, searchTerm = "") => {
  const params: AxiosRequestConfig["params"] = {
    sort: "createdAt:desc",
    page: page,
    pageSize: pageSize,
    search: searchTerm,
  }

  const data = await HttpClient.get(`/api/media`, { params })
  return data
}

export const fetchMediaId = async (id: number) => {
  const response = await HttpClient.get(`${API_PREFIX_MEDIA_PATH}/files/${id}`)
  return response
}

export const deleteMedia = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_MEDIA_PATH}/files/${id}`)
}
export const updateMedia = async (id: number, data: FormData) => {
  return await HttpClient.post(`${API_PREFIX_MEDIA_PATH}?id=${id}`, data)
}
export const addMedia = async (data: FormData) => {
  return await HttpClient.post(`${API_PREFIX_MEDIA_PATH}`, data)
}
